module.exports = __webpack_public_path__ + "assets/img/ewm.bfd78f3a.jpg";